import { render, staticRenderFns } from "./NavbarCollapseContent.vue?vue&type=template&id=2ea95242&scoped=true"
import script from "./NavbarCollapseContent.vue?vue&type=script&lang=ts"
export * from "./NavbarCollapseContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea95242",
  null
  
)

export default component.exports